import {
	Component,
	OnInit,
	Input,
	OnDestroy,
	ViewChild,
	AfterViewInit,
	ContentChild,
	TemplateRef,
	ViewEncapsulation,
	ChangeDetectorRef,
	EventEmitter,
	Output,
	SimpleChanges,
	OnChanges
} from "@angular/core";
import { IdService } from "../shared/services/id.service";

import { Locale, Row, DataTypes } from "./datatable.models";
import { formatNumber } from "../shared/utils/formatting";
// import { currencyOpts } from '../../shared/constants/common';
// import { sortTypes } from '../../shared/types/common';
import { DatatableService } from "./datatable.service";
import { DatatableGlobalSearcherComponent } from "./datatable-global-searcher/datatable-global-searcher.component";
import { PaginatorComponent } from "./../paginator/paginator.component";

@Component({
	selector: "rbc-datatable",
	templateUrl: "./datatable.component.html",
	encapsulation: ViewEncapsulation.None,
	providers: [DatatableService]
})
export class DatatableComponent implements OnInit, OnDestroy, AfterViewInit, OnChanges {
	@Input() id: string;
	@Input() componentsToRegister: Object;
	@Input() title;
	@Input() columns: any[]; // The columns of the table
	@Input() columnsGroup: boolean; // Enable the function to copy the data into the clipboard to paste it on excel etc.

	_rows: Row[];
	get rows(): Row[] {
		return this._rows;
	}
	@Input() set rows(value: Row[]) {
		this._rows = value;
		this.filteredRows = this.rows;

		// ensure checkboxes have proper state
		if (this.selectableRows) {
			this.$_Datatable_rowSelectedState(undefined);
		}
	}

	_expandAll;

	get expandAll(){
		return this._expandAll
	}
	@Input() set expandAll(val){
		this._expandAll = val;
		if (this._expandAll) {
			this.expandedRows = this.rows;
		} else {
			this.expandedRows = [];
		}
	}

	@Input() pagination: boolean; // Set if the table is paginated.
	@Input() compact: boolean;
	@Input() customizableColumns: boolean; // Set if the table's columns are customizable
	@Input() sortable: boolean; // Set if the table is sortable
	@Input() preventSort: boolean; // Set if you want to sort the datatable data manually
	@Input() globalSearch: boolean; // Set if the table is global searchable
	@Input() advancedSearch: boolean; // Seti fi the table is advanced searchable
	@Input() selectableRows: boolean; // Set if the table rows are selectable
	@Input() responsiveColumns: boolean; // Set if the columns responsive
	@Input() headerFixed: boolean; // Set if the table header is fixed
	@Input() height;
	@Input() columnFixed: boolean; // Set if the table has fixed column
	@Input() expandableRow: boolean; // Set if the table row is expandable;
	@Input() expandableRowArrow = true; // Show or hide the arrow for the expandable row feature
	@Input() expandableRowContentValidator: Function; // The rule of expandable row's content
	@Input() downloadJson: boolean; // Enable the function to download the data as a JSON file
	@Input() downloadCsv: boolean; // Enable the function to download the data as a CSV File
	@Input() copy: boolean; // Enable the function to copy the data into the clipboard to paste it on excel etc.
	@Input() paginationDisplay = [5, 10, 30, 50];
	@Input() paginationDisplayPreselected;
	@Input() paginationDisplaySelect: boolean = true;
	@Input() disableStripes: boolean;
	@Input() set value(val){
		this._value = val;
		this.$_Datatable_rowSelectedState(val.allSelectedRows);
	};

	get value(){
		return this._value;
	}

	_value;
	@Input() advancedSearchPlaceholder = "Search";
	@Input() columnFilterLabel = "Show/Hide column:";
	@Input() columnFilterCheckedText = "columns";
	@Input() globalSearchPlaceholder = "Search";
	@Input() sortLabel = "Sort";
	@Input() sortUpLabel = "Sort up";
	@Input() sortDownLabel = "Sort down";
	@Input() paginationPreviousLabel = "Prev.";
	@Input() paginationNextLabel = "Next";
	@Input() paginationDisplayLabel = "Display";
	@Input() downloadDataAsJSONLabel = "Download data as JSON";
	@Input() downloadDataAsCSVLabel = "Download data as CSV";
	@Input() copyDataLabel = "Copy visible data to clipboard";
	@Input() copiedSuccessfulMessage = "Data copied to clipboard!";
	//Custom Slots
	@Input() customTitle;
	@Input() customFilters;

	@Output() onColumnsChanged = new EventEmitter();
	@Output() onPageSizeSelectChanged = new EventEmitter();
	@Output() onRowSelected = new EventEmitter();
	@Output() onRowDeslected = new EventEmitter();
	@Output() onAllRowsSelected = new EventEmitter();
	@Output() onAllRowsDeselcted = new EventEmitter();
	@Output() onPaginatorButtonClicked = new EventEmitter();
	@Output() onSortChanged = new EventEmitter();
	@Output() onRowExpanded = new EventEmitter();
	@Output() checkBoxUpdate = new EventEmitter();
	@Output() onGlobalSearchFocusOut = new EventEmitter();
	@Output() onGlobalSearchTermUpdate = new EventEmitter();

	@ViewChild("globalsearcher", { static: false })
	globalSearcher: DatatableGlobalSearcherComponent;

	@ViewChild("paginator", { static: false })
	paginator: PaginatorComponent;

	@ContentChild("cellTemplate", { static: false })
	cellTemplate: TemplateRef<any>;

	@ContentChild("rowCellFixedTemplate", { static: false })
	rowCellFixedUserTemplate: TemplateRef<any>;

	@ContentChild("expandableRowTemplate", { static: false })
	expandRowUserTemplate: TemplateRef<any>;


	filteredRows = []; // Store all Filtered rows
	selectedRows = []; // Store all selected rows
	selectAll = false;
	// #endregion -- General

	// #region [REGION_CODE_CORAL] -- Pagination
	currentPage = 1;
	currentPageSize = 10;
	// #endregion -- Pagination

	// #region [REGION_CODE_GOLD] -- Sort
	sortedColumn = {}; // Current sorted column
	sortedColumnIndex = 0; // Current sorted column index
	sortType = "asc"; // Current sort type
	// #endregion -- Sort

	// #region [REGION_CODE_MAGENTA] -- Global Search
	//  Global Search
	isGlobalSearchable = this.globalSearch;
	globalSearchTerm = "";
	// #endregion -- Global Search

	// #region [REGION_CODE_AZURE] -- Expand Row
	expandedRows = [];
	// #endregion -- Expand Row

	// #region [REGION_CODE_BLUE] -- Advanced Search
	advancedSearchObjects = [];
	// #endregion -- Advanced Search
	tbodyWidth = "";
	thGroupHeigth = "";
	copyFeedbackActive = false;
	isIE = !!window["MSInputMethodContext"] && !!document["documentMode"];
	mainColumnPresent = false;
	locale = Locale;
	indeterminate = false;


	constructor(
		private idService: IdService,
		private changeDetector: ChangeDetectorRef,
		private datatableService: DatatableService
	) {
		this.id = this.idService.generate();
	}

	ngOnChanges(changes: SimpleChanges): void {
		if(changes["selectableRows"]) {
			if(this.rows.length > 0){
				this.$_Datatable_rowSelectedState(this.rows);
			}
		}
	}

	displayedRowsOnPage(): Row[]{
		if (this.pagination) {
			return this.paginatedRows;
		} else {
			// this.$_Datatable_resetFilteredRows();
			return this.filteredRows;
		}
	}

	//#endregion -- General Helpers Region

	// #region [REGION_CODE_CORAL] -- Pagination
	// Total pages based on current page size
	get totalPages() {
		if (this.filteredRows) {
			return Math.ceil(this.filteredRows.length / this.currentPageSize);
		} else {
			return null;
		}
	}

	// Rows displayed on current page
	get paginatedRows() {
		if (this.filteredRows) {
			return this.filteredRows.filter((row, index) => {
				let start = (this.currentPage - 1) * this.currentPageSize;
				let end = this.currentPage * this.currentPageSize;
				if (index >= start && index < end) {
					return true;
				}
			});
		} else {
			return null;
		}
	}
	// #endregion -- Pagination

	// #region [REGION_CODE_BLUE] -- Fixed Header
	get headerFixedStyle() {
		if (this.headerFixed) {
			let height = this.height ? this.height : 400;

			return {
				height: typeof height !== "string" ? `${height}px` : height
				// width: this.tbodyWidth
			};
		} else {
			return null;
		}
	}

	// #endregion -- Fixed Header

	get mainColumnIndex() {
		const _self = this;
		if (_self.mainColumnPresent) {
			let columnsLength = _self.columns.length;
			let columnIndex = 0;
			for (let i = 0; i < columnsLength; i++) {
				if (_self.columns[i].main) {
					columnIndex = i;
					break;
				}
			}
			return columnIndex;
		} else {
			return 0;
		}
	}

	selectAllIsDisabled() {
		const visibleRows = this.pagination ? this.displayedRowsOnPage() : this.filteredRows;
		const disabledRows = visibleRows.filter(row => row.disabled);
		return disabledRows.length > 0 || visibleRows.length === 0;
	}

	get responsiveColumnsHelper() {
		return this.responsiveColumns;
	}

	set responsiveColumnsHelper(responsiveColumnsEnabled) {
		if (typeof window !== "undefined" && responsiveColumnsEnabled) {
			window.addEventListener("resize", this.$_Datatable_onWindowSizeChanged);
		} else {
			if (typeof window !== "undefined") {
				window.removeEventListener(
					"resize",
					this.$_Datatable_onWindowSizeChanged
				);
			}
		}
	}

	ngOnInit() {
		this.filteredRows = this.rows;
		if (this.columns) {
			this.mainColumnPresent =
				this.columns.filter(col => col.main).length > 0;
		}

		if (this.pagination) {
			this.paginationDisplayPreselected = this.paginationDisplayPreselected ? this.paginationDisplayPreselected : this.paginationDisplay[0]
			this.$_Datatable_paginator_onPageSizeSelectChanged({
				currentPage: this.currentPage,
				pageSize: this.paginationDisplayPreselected,
				firstChange: true
			});
		}
	}

	ngAfterViewInit() {
		const _self = this;

		// Init columns by window size
		if (this.responsiveColumns) {
			this.$_Datatable_onWindowSizeChanged();
		}

		// Add Event Listerner for responsive columns if applied
		if (this.responsiveColumns) {
			window.addEventListener(
				"resize", () =>
				_self.$_Datatable_onWindowSizeChanged()
			);
		}

		if (_self.copy) {
			setTimeout(() => {
				document
					.getElementById(_self.id)
					.addEventListener("copy", e =>
						_self.$_Datatable_overwriteClipboardData(e)
					);
			}, 0);
		}
	}

	ngOnDestroy() {
		window.removeEventListener(
			"resize",
			e =>
				this.$_Datatable_overwriteClipboardData(e)
		);
	}

	// #region [REGION_CODE_GOLD] -- General Helper Methods Region

	// Reset filtered rows
	$_Datatable_resetFilteredRows() {
		// Set filtered rows back to original state
		this.filteredRows = this.rows;
	}

	// Get column by column index
	$_Datatable_getColumnByColumnIndex(columnIndex) {
		return this.columns[columnIndex];
	}

	// Reset columns when windows size changed
	$_Datatable_onWindowSizeChanged() {
		//  Reset columns when windows size changed
		let windowWidth = document.documentElement.getBoundingClientRect()
			.width;
		if (this.columns) {
			if (windowWidth >= 1200) {
				// Reset column visibility by screen size
				this.columns.forEach(c => {
					c.show = c.showForLargeScreen;
				});
			}

			if (windowWidth >= 568 && windowWidth < 1200) {
				// Reset column visibility by screen size
				this.columns.forEach(c => {
					c.show = c.showForMediumScreen;
				});
			}

			if (windowWidth < 568) {
				// Reset column visibility by screen size
				this.columns.forEach(c => {
					c.show = c.showForSmallScreen;
				});
			}
		}

	}
	// #endregion -- General Helper Methods region

	// #region [REGION_CODE_CORAL] -- Pagination Methods Region
	$_Datatable_Paginator_onPaginatorButtonClicked(clickedButton) {
		this.currentPage = clickedButton.pageNumber;
		this.onPaginatorButtonClicked.emit(clickedButton);

		// Set checkbox status if selectableRows of last state
		if (this.selectableRows) {
			// update checkbox status depending on the row's stored checked state
			this.selectedRows = this.displayedRowsOnPage().filter(row => row.checked);

			// ensure select all checkbox is updated
			this.selectAll = this.displayedRowsOnPage().length === this.selectedRows.length;
			this.indeterminate = !!this.selectedRows.length && !this.selectAll;
			// keep the model up to date
			this.checkBoxUpdate.emit({
				currentSelectedRow: null,
				currentDeselectedRow: null,
				allSelectedRows: this.selectedRows
			});
		}
	}
	$_Datatable_paginator_onPageSizeSelectChanged(pageSizeObject) {
		this.currentPage = pageSizeObject.currentPage;
		this.currentPageSize = pageSizeObject.pageSize;
		this.$_Datatable_resetFilteredRows();


		// Redo the global search if applied
		if (this.isGlobalSearchable && this.globalSearchTerm) {
			this.$_Datatable_filterRowsByGlobalSearch();
		}

		// Redo the sort if applied
		if (
			this.sortable &&
			this.sortedColumn &&
			this.sortedColumnIndex &&
			this.sortType
		) {
			this.$_Datatable_sortFilteredRows(
				this.sortedColumn,
				this.sortedColumnIndex,
				this.sortType
			);
		}

		// Set checkbox status if selectableRows to unchecked
		if (this.selectableRows && !pageSizeObject["firstChange"]) {
			// reset all checkboxes to reduce unknowns / hidden checked checkboxes
			this.selectedRows = [];
			this.selectAll = false;
			this.indeterminate = false;

			// keep the model up to date
			this.checkBoxUpdate.emit({
				currentSelectedRow: null,
				currentDeselectedRow: null,
				allSelectedRows: []
			});

			// set checked state to false for all rows
			this.rows.forEach(checkbox =>
				checkbox["checked"] = false
			);
		}

		this.onPageSizeSelectChanged.emit({
			pageSize: pageSizeObject.pageSize
		});
	}
	// #endregion -- Pagination Methods Region

	// #region [REGION_CODE_BLUE] -- Customizable Columns Methods Region

	// Called when column filter updated
	$_Datatable_onColumnFilterCheckBoxUpdated(selectedColumns) {
		//  reset the globalSearchTerm
		if (this.globalSearcher) {
			this.globalSearcher.$_GlobalSearch_reset();
		}
		selectedColumns.forEach((c, i) => {
			this.columns[i].show = c.selected;
		});
		// Emit the 'onColumnsChanged' event with selected columns
		this.onColumnsChanged.emit(selectedColumns);
	}
	// #endregion -- Customizable Columns Methods Region

	// #region [REGION_CODE_GOLD] -- Sortable Methods Region

	// Sort table by column index
	$_Datatable_sort(column, columnIndex) {
		// If current table is not sortable , simply return.
		if (!this.sortable) {
			return;
		}

		// If current column is not sortable, simply return.
		if (!this.$_Datatable_isSortableColumn(columnIndex)) {
			return;
		}

		// Flip sort type if resort current column, otherwise sort by asc.
		if (this.sortedColumnIndex === columnIndex) {
			this.sortType = this.sortType === "asc" ? "desc" : "asc";
		} else {
			this.sortType = "desc";
		}

		// Set current softed column and index
		this.sortedColumn = column;
		this.sortedColumnIndex = columnIndex;

		if (!this.preventSort) {
			// If we want to prevent default sort
			// Sort the filtered rows by column index and sort type
			this.$_Datatable_sortFilteredRows(
				this.sortedColumn,
				this.sortedColumnIndex,
				this.sortType
			);
		}

		// Expose the onSortChanged event
		this.onSortChanged.emit({
			sortType: this.sortType,
			sortedColumnIndex: this.sortedColumnIndex
		});
	}
	// Get the sortable status of column by index
	$_Datatable_isSortableColumn(columnIndex) {
		const { sortable } = this.columns[columnIndex];
		return sortable;
	}

	// Sort table by data type and sort type
	$_Datatable_sortFilteredRows(column, columnIndex, sortType) {
		let modifier = 1;
		if (sortType === "desc") {
			modifier = -1;
		}
		if (typeof column.sortField !== "undefined") {
			if (column.dataType === "number") {
				this.filteredRows = this.filteredRows.sort((a, b) => {
					if (a.cells[columnIndex][column.sortField] - b.cells[columnIndex][column.sortField] > 0) return 1 * modifier;
					if (a.cells[columnIndex][column.sortField] - b.cells[columnIndex][column.sortField] < 0) return -1 * modifier;
					return 0;
				});
			} else {
				this.filteredRows = this.filteredRows.sort((a, b) => {
					const aCell = a.cells[columnIndex][column.sortField] === null ? '' : a.cells[columnIndex][column.sortField];
					const bCell = b.cells[columnIndex][column.sortField] === null ? '' : b.cells[columnIndex][column.sortField];
					if (aCell > bCell) return 1 * modifier;
					if (aCell < bCell) return -1 * modifier;
					return 0;
				});
			}
		} else {
			if (
				typeof column.dataType !== "undefined" &&
				column.dataType === "number"
			) {
				this.filteredRows = this.filteredRows.sort((a, b) => {
					if (a.cells[columnIndex] - b.cells[columnIndex] > 0) return 1 * modifier;
					if (a.cells[columnIndex] - b.cells[columnIndex] < 0) return -1 * modifier;
					return 0;
				});
			} else {
				this.filteredRows = this.filteredRows.sort((a, b) => {
					const aCell = a.cells[columnIndex] === null ? '' : a.cells[columnIndex];
					const bCell = b.cells[columnIndex] === null ? '' : b.cells[columnIndex];
					if (aCell > bCell) return 1 * modifier;
					if (aCell < bCell) return -1 * modifier;
					return 0;
				});
			}
		}
	}
	// #endregion [REGION_CODE_GOLD] -- Sortable Methods Region

	// #region [REGION_CODE_MAGENTA] -- Global Search Region
	$_Datatable_onGlobalSearchFocusOut(obj) {
		// Update global search term
		this.globalSearchTerm = obj.value;
		// Emit the event of onGlobalSearchFocusOut, which happens when the global search input focus out
		this.onGlobalSearchFocusOut.emit(obj);
	}
	$_Datatable_onGlobalSearchTermUpdate(obj) {
		// Update global search term
		this.globalSearchTerm = obj.value;
		// Filter rows by global search term
		this.$_Datatable_filterRowsByGlobalSearch();

		// Emit the event of onGlobalSearchFocusOut, which happens when the global search term changes
		this.onGlobalSearchTermUpdate.emit(obj.value);

		// Reset current page to first page
		if (this.paginator) {
			this.paginator.$_Paginator_onFirstPageButtonClicked();
		}

		// Reset advanced searchers
		let advancedSearchers = document.querySelectorAll(
			"[id^='rbc-datatable-advanced-searcher-']"
		);
		advancedSearchers.forEach(as => {
			if (as["value"] !== "") {
				as["value"] = "";
			}
		});

		this.advancedSearchObjects = [];
	}
	$_Datatable_filterRowsByGlobalSearch() {
		this.filteredRows = this.rows.filter(r => {
			let hasTerm = false;
			r.cells
				.filter((cell, cellIndex) => {
					const currentColumn = this.$_Datatable_getColumnByColumnIndex(cellIndex);
					return (typeof currentColumn.searchable === "undefined" || currentColumn.searchable);
				})
				.forEach((cell, cellIndex) => {
					const currentColumn = this.$_Datatable_getColumnByColumnIndex(cellIndex);
					if (typeof cell !== "undefined" && cell != null && typeof cell.value !== "undefined" && cell.value != null) {
						let myValue = cell.value;
						if (currentColumn.dataType === "date") {
							let timeZoneName = currentColumn.dataDateTimeZone || "UTC";
							myValue = new Date(cell.value).toLocaleString(currentColumn.dataDateLocale ||
								"en-us", { ...currentColumn.dataDateFormat, timeZone: timeZoneName });
						}
						if (myValue.toString().toLowerCase().indexOf(this.globalSearchTerm.toLowerCase()) > -1) {
							hasTerm = true;
							return;
						}
					} else if (cell) {
						let myValue = cell;
						if (currentColumn.dataType === "date") {
							let timeZoneName = currentColumn.dataDateTimeZone || "UTC";
							myValue = new Date(cell).toLocaleString(currentColumn.dataDateLocale ||
								"en-us", { ...currentColumn.dataDateFormat, timeZone: timeZoneName });
						}
						if (myValue.toString().toLowerCase().indexOf(this.globalSearchTerm.toLowerCase()) > -1) {
							hasTerm = true;
							return;
						}
					}
				});
			return hasTerm;
		});
		if (this.pagination) {
			this.currentPage = 1;
		}
		if (this.selectableRows) {
			this.$_Datatable_rowSelectedState();
			// const checkedRowLength = this.filteredRows.filter(row => row.checked).length;
			// if (this.filteredRows.length === checkedRowLength) {
			// 	this.selectAll = true;
			// 	this.indeterminate = false;
			// } else {
			// 	this.selectAll = !!checkedRowLength;
			// 	this.indeterminate = !!checkedRowLength;
			// }
		}
	}
	// #endregion -- Global Search Region

	// #region [REGION_CODE_BLUE] -- Selectable Rows

	resetRowsSelected(){
		this.displayedRowsOnPage().forEach(checkbox =>
			checkbox["checked"] = false
		);
		this.indeterminate = false;
		this.selectAll = false;
	}

	// Called when the row selected by click the checkbox in the first column
	$_Datatable_rowSelected(event, index, row) {
		const selectedRowsCount = this.selectedRows.length;
		// If row selected, push row to the selectedRows array, otherwise remove it from the array
		if (event) {
			// Add selected row to the selectedRows array
			this.selectedRows.push(row);

			// Emit the onRowSelected event
			this.onRowSelected.emit({
				allSelectedRows: this.selectedRows,
				currentSelectedRow: row
			});

			this.checkBoxUpdate.emit({
				allSelectedRows: this.selectedRows,
				currentSelectedRow: row.id,
				currentDeselectedRow: null
			});
		} else {
			// Remove selected row from selectedRows array
			this.selectedRows.pop();

			// Emit the onRowDeselected event
			this.onRowDeslected.emit({
				deSelectedRow: row
			});

			this.checkBoxUpdate.emit({
				currentSelectedRow: null,
				currentDeselectedRow: row.id,
				allSelectedRows: this.selectedRows
			});
		}

		if (this.selectedRows.length <= 0) {
			// reset select all checkbox if nothing selected
			this.selectAll = false;
			this.indeterminate = false;
		} else if (
			(this.selectedRows.length < this.filteredRows.length && !this.pagination) ||
			(this.selectedRows.length < this.paginatedRows.length && this.pagination)
		) {
			this.selectAll = true;
			this.indeterminate = true;
		} else {
			this.selectAll = true;
			this.indeterminate = false;
		}

	}

	// Called when all rows selected by click the checkbox of selectAll
	$_Datatable_allRowsSelectedUpdate(event) {
		if (event) {
			this.selectedRows = [];

			if (this.pagination) {
				// If pagination enabled, select current displayed rows on page.
				this.displayedRowsOnPage().forEach(r => {
					this.selectedRows.push(r);
				});
			} else {
				// if pagination disabled, select filtered rows
				this.filteredRows.forEach(r => {
					this.selectedRows.push(r);
				});
			}

			this.displayedRowsOnPage().forEach(checkbox =>
				checkbox["checked"] = true
			);

			// Emit the onAllRowsSelected event.
			this.onAllRowsSelected.emit({
				// to remove on v2
				allSelectedRows: this.selectedRows
			});
			this.checkBoxUpdate.emit({
				currentSelectedRow: null,
				currentDeselectedRow: null,
				allSelectedRows: this.selectedRows
			});
			this.selectAll = true;
		} else {
			// if checkbox unchecked, remove all from the selectedRows array
			this.selectedRows = [];

			this.displayedRowsOnPage().forEach(checkbox =>
				checkbox["checked"] = false
			);

			// Emit the onAllRowsDeselected event.
			this.onAllRowsDeselcted.emit();
			this.checkBoxUpdate.emit({
				currentSelectedRow: null,
				currentDeselectedRow: null,
				allSelectedRows: []
			});
			this.selectAll = false;
			this.indeterminate = false;

		}
	}

	$_Datatable_rowSelectedState(rows?) {
		const visibleRows = this.pagination ? this.displayedRowsOnPage() : this.filteredRows;
		this.selectedRows = (rows || visibleRows).filter(row => row.checked);
		if (visibleRows.length) {
			this.indeterminate = this.selectedRows.length > 0 && visibleRows.length !== this.selectedRows.length;
			this.selectAll = (visibleRows.length > 0 && visibleRows.length === this.selectedRows.length) || this.indeterminate;
		} else {
			this.indeterminate = false;
			this.selectAll = false;
		}

	}

	// #endregion

	// #region [REGION_CODE_AZURE] -- Expand Row
	$_Datatable_isRowExpanded(row) {
		// Check if current row is in the expandedRows array
		return this.expandedRows.indexOf(row) > -1;
	}
	// Called when the expand arrow has been clicked.
	$_Datatable_onExpandArrowClicked(row) {
		// If current row expanded, then fold the current row
		// else Set the expandedRow as current row
		if (this.$_Datatable_isRowExpanded(row)) {
			this.expandedRows = this.expandedRows.filter(r => r !== row);
			this.onRowExpanded.emit(row);
		} else {
			this.expandedRows.push(row);
			this.onRowExpanded.emit(row);
		}
	}
	$_Datatable_isExpandedRowValid(row) {
		return this.expandableRowContentValidator
			? this.expandableRowContentValidator(row)
			: true;
	}

	// #endregion -- Expand Row
	// #region [REGION_CODE_BLUE] -- Advanced Search
	$_Datatable_onAdvancedSearchObjectUpdate(advancedSearchObject) {
		if (this.advancedSearchObjects.filter(o => o.column === advancedSearchObject.column).length === 0 && advancedSearchObject.value !== "") {
			this.advancedSearchObjects.push(advancedSearchObject);
		} else {
			if (advancedSearchObject.value !== "") {
				this.advancedSearchObjects.map(o => {
					if (o.column === advancedSearchObject.column) {
						o.value = advancedSearchObject.value;
					}
				});
			} else {
				this.advancedSearchObjects = this.advancedSearchObjects.filter( o => {
						return o.column !== advancedSearchObject.column;
					}
				);
			}
		}

		if (
			this.globalSearcher &&
			this.globalSearcher.globalSearchTerm !== ""
		) {
			this.globalSearcher.$_GlobalSearch_reset();
		}
		// Reset current page to first page

		if (this.paginator) {
			this.paginator.$_Paginator_onFirstPageButtonClicked();
		}

		this.$_Datatable_filterRowsByAdvancedSearch();
	}

	$_Datatable_filterRowsByAdvancedSearch() {
			this.filteredRows = this.rows.filter(r => {
				let hasTerm: any = true;
				this.advancedSearchObjects.map(o => {
					r.cells.map((cell, cellIndex) => {
						let currentColumn = this.$_Datatable_getColumnByColumnIndex(cellIndex);
						if (typeof currentColumn.sortField !== "undefined") {
							let myValue = cell.value;
							if (currentColumn.dataType === "date") {
								let timeZoneName = currentColumn.dataDateTimeZone || "UTC";
								myValue = new Date(cell.value).toLocaleString(currentColumn.dataDateLocale || "en-us",
								{...currentColumn.dataDateFormat, timeZone: timeZoneName});
							}
							if (currentColumn === o.column) {
								hasTerm = hasTerm * myValue.toString().toLowerCase().indexOf(o.value.toLowerCase()) > -1;
							}
						} else {
							let myValue = cell;
							if (currentColumn.dataType === "date") {
								let timeZoneName = currentColumn.dataDateTimeZone || "UTC";
								myValue = new Date(cell).toLocaleString(currentColumn.dataDateLocale ||
									"en-us", {...currentColumn.dataDateFormat, timeZone: timeZoneName});
							}
							if (currentColumn === o.column) {
								hasTerm = hasTerm * myValue.toString().toLowerCase().indexOf(o.value.toLowerCase()) > -1;
							}
						}
					});
				});
				return hasTerm;
			});
			this.currentPage = 1;
		}

	// #endregion -- Advanced Search
	// #region [REGION_CODE_BLUE] -- Export data
	$_Datatable_generateJSON() {
		const _self = this;
		let extract = [];
		_self.filteredRows.forEach(row => {
			let tempRow = {};
			row.cells.forEach((cell, index) => {
				if (typeof _self.columns[index].sortField !== "undefined") {
					tempRow[_self.columns[index].header] = cell.value;
				} else {
					tempRow[_self.columns[index].header] = cell;
				}
			});
			extract.push(tempRow);
		});
		let blob = new Blob([JSON.stringify(extract)], {
			type: "application/json"
		});
		_self.$_Datatable_downloadData(blob, "table-data.json");
	}
	$_Datatable_generateCSV() {
		const _self = this;
		let extract = [];
		let extractString;
		let headers = _self.columns.map(el => {
			return "\"" + el.header.split("\"").join("\"\"") + "\"";
		});
		extract.push(headers.join(","));
		_self.filteredRows.map(row => {
			let tempRow = [];
			row.cells.forEach((val, columnIndex) => {
				if (
					typeof _self.columns[columnIndex].sortField !== "undefined"
				) {
					tempRow.push(
						"\"" +
						String(val.value)
							.split("\"")
							.join("\"\"") +
						"\""
					);
				} else {
					tempRow.push(
						"\"" +
						String(val)
							.split("\"")
							.join("\"\"") +
						"\""
					);
				}
			});
			let formattedRow = tempRow.join(",");
			extract.push(formattedRow);
			return formattedRow;
		});
		extractString = extract.join("\n");
		let blob = new Blob([extractString], { type: "text/csv" });
		_self.$_Datatable_downloadData(blob, "table-data.csv");
	}
	$_Datatable_generateCopy() {
		const _self = this;
		let extract = [];
		let extractString;
		let headers = [];
		_self.columns.forEach(el => {
			if (el.show) {
				headers.push("\"" + el.header.split("\"").join("\"\"") + "\"");
			}
		});
		extract.push(headers.join("\t"));
		_self.filteredRows.map(row => {
			let tempRow = [];
			row.cells.forEach((val, index) => {
				if (_self.columns[index].show) {
					if (typeof _self.columns[index].sortField !== "undefined") {
						tempRow.push(
							"\"" +
							String(val.value)
								.split("\"")
								.join("\"\"") +
							"\""
						);
					} else {
						tempRow.push(
							"\"" +
							String(val)
								.split("\"")
								.join("\"\"") +
							"\""
						);
					}
				}
			});
			let formattedRow = tempRow.join("\t");
			extract.push(formattedRow);
			return formattedRow;
		});
		extractString = extract.join("\n");
		return extractString;
	}
	$_Datatable_emitCopyEvent() {
		const _self = this;
		// Create a fake textarea to capture the copy event and execute the clipboard overwrite.
		const el = document.createElement("textarea");
		el.addEventListener("copy", e =>
			_self.$_Datatable_overwriteClipboardData(e)
		);
		el.setAttribute("readonly", "");
		el.style.position = "absolute";
		el.style.left = "-9999px";
		document.body.appendChild(el);
		el.select();
		document.execCommand("copy");
		document.body.removeChild(el);
	}
	$_Datatable_overwriteClipboardData(e) {
		const _self = this;
		let textSelected = false;
		if (typeof window.getSelection !== "undefined") {
			textSelected = window.getSelection().toString() !== "";
		}
		if (!textSelected) {
			e.preventDefault();
			if (window["clipboardData"] && window["clipboardData"].setData) {
				window["clipboardData"].setData(
					"Text",
					_self.$_Datatable_generateCopy()
				);
			} else if (e.clipboardData && e.clipboardData.setData) {
				e.clipboardData.setData(
					"text/plain",
					_self.$_Datatable_generateCopy()
				);
			} else if (
				e.originalEvent &&
				e.originalEvent.clipboardData.setData
			) {
				e.originalEvent.clipboardData.setData(
					"text/plain",
					_self.$_Datatable_generateCopy()
				);
			}
			e.clipboardData.setData(
				"text/plain",
				_self.$_Datatable_generateCopy()
			);
			_self.copyFeedbackActive = true;
		}
	}
	$_Datatable_downloadData(blob, filename) {
		let element = document.createElement("a");
		if (blob) {
			if (navigator.msSaveOrOpenBlob) {
				navigator.msSaveOrOpenBlob(blob, filename);
			} else {
				element.setAttribute("href", window.URL.createObjectURL(blob));

				// set file title
				element.setAttribute("download", filename);

				// trigger download
				element.style.display = "none";
				document.body.appendChild(element);
				element.click();

				// remove temporary link element
				document.body.removeChild(element);
			}
		}
	}
	// #endregion -- Export data
	// #region [REGION_CODE_BLUE] -- Columns group
	$_Datatable_columnsGroupColspan(columns) {
		let columnGroups = [];
		let colspan = 1;

		for (let index = 0; index < columns.length; index++) {
			if (columns[index].show) {
				if (typeof columns[index].headerGroup === "undefined") {
					columnGroups[index] = 1;
				} else {
					if (typeof columns[index + 1] !== "undefined") {
						if (
							columns[index + 1].headerGroup !==
							columns[index].headerGroup
						) {
							columnGroups[index] = colspan;
							colspan = 1;
						} else {
							columnGroups[index] = 0;
							colspan++;
						}
					} else {
						// last element
						if (
							columns[index - 1].headerGroup ===
							columns[index].headerGroup
						) {
							columnGroups[index] = colspan;
						}
					}
				}
			}
		}

		return columnGroups;
	}
	$_RegisterComponents_template(
		name,
		template,
		componentMethods = null,
		componentComponents = null
	) {
		let componentsObject = this.componentsToRegister || {};
		if (componentComponents != null) {
			componentsObject = { ...componentsObject, ...componentComponents };
		}
		return {
			name: name,
			components: componentsObject,
			methods: componentMethods,
			template: template
		};
	}
	// #region [REGION_CODE_BLUE] -- Cell
	$_DatatableCell_cellDisplayValue(value, column) {
		if (column && (value || value === 0)) {
			if (column.dataType === "number") {
				let displayNumber = column.formatNumber
					? formatNumber(
						value.toString().replace("-", ""),
						column.formatNumberLang || "en",
						column.formatNumberDecimal || 2
					)
					: value.toString().replace("-", "");
				let prefix = "";
				let suffix = "";
				if (column.colored) {
					if (value < 0) {
						prefix = "<span class='c-alert-red'>";
						suffix = "</span>";
					} else if (value > 0) {
						prefix = "<span class='c-alert-green'>";
						suffix = "</span>";
					}
				}
				let indicator =
					value === 0
						? ""
						: column.signed
							? value < 0
								? "-"
								: "+"
							: column.arrow
								? value < 0
									? "<span class='far fa-long-arrow-alt-down'></span> -"
									: "<span class='far fa-long-arrow-alt-up'></span> &nbsp;"
								: value < 0
									? "-"
									: "";
				if (column.dataUnit) {
					if (
						column.dataUnit === "%" ||
						column.dataUnit === " %" ||
						(typeof column.dataUnitPosition !== "undefined" &&
							column.dataUnitPosition === "right")
					) {
						return (
							prefix +
							indicator +
							displayNumber +
							column.dataUnit +
							suffix
						);
					} else {
						return (
							prefix +
							indicator +
							column.dataUnit +
							displayNumber +
							suffix
						);
					}
				} else {
					return prefix + indicator + displayNumber + suffix;
				}
			} else if (column.dataType === "date") {
				let timeZoneName = column.dataDateTimeZone || "UTC";
				return new Date(value).toLocaleString(
					column.dataDateLocale || "en-us",
					{ ...column.dataDateFormat, timeZone: timeZoneName }
				);
			} else {
				return value;
			}
		} else {
			return "-";
		}
	}
	$_DatatableCell_getCellDisplayValueByColumnIndex(row, columnIndex, column) {
		if (typeof column.sortField !== "undefined") {
			return this.$_DatatableCell_cellDisplayValue(
				row.cells[columnIndex].value,
				column
			);
		} else {
			return this.$_DatatableCell_cellDisplayValue(
				row.cells[columnIndex],
				column
			);
		}
	}
	// #endregion -- Cell

	rowHeader(column, row, columnIndex) {
		return ((typeof column.headerGroup !== "undefined" && this.columnsGroup)
			? `${this.id}columnHeaderColspan${column.headerGroup} `
			: "") + `${this.id}columnHeader${columnIndex}`
			+ ((!column.main && this.mainColumnPresent)
				? ` ${this.id}rowHeader${row.id}` : "");
	}

	isSearchable(isSearchable) {
		return (typeof isSearchable === "undefined" || isSearchable);
	}
}
